/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/**
 * Zone JS is required by Angular.
 */
import 'zone.js';

/**
 * Application-specific polyfills
 */

// IndexedDB getall Polyfill (keep if needed for older browsers)
import 'indexeddb-getall-shim';

/**
 * Polyfill for require() used by fitforce-document-sync library
 * This is a minimal implementation that handles JSON schema loading
 */
(window as any).require = function(path: string) {
  // Handle relative paths for JSON schemas
  if (path.includes('schema.json')) {
    console.warn('require() called for:', path);
    console.warn('JSON schemas should be bundled or imported statically');
    // Return empty schema object to prevent errors
    // The library should be updated to import schemas statically
    return {};
  }
  console.error('require() called with unsupported path:', path);
  return {};
};
